import { externalShipmentAffLocationScannedValidate } from '../../application/dtos/external_shipment_aff_location_scanned_validate';
import { externalShipmentAffProductScannedValidate } from '../../application/dtos/external_shipment_aff_product_scanned_validate';

export class ExternalShipmentAffScannedEntity {

    constructor({type, ...rest}){

        if(type === "product") {
            const { product_id, detailed_stock_id, location_id, location_completed, session_completed, scanned, required } = rest;

            this.product_id = product_id;
            this.detailed_stock_id = detailed_stock_id;
            this.location_id = location_id;
            this.location_completed = location_completed;
            this.session_completed = session_completed;
            this.scanned = scanned;
            this.required = required;
        } 
        else if(type === "location") {
            const { location_id, location_name, status, products } = rest;
            
            this.location_id = location_id;
            this.location_name = location_name;
            this.status = status;
            this.products = products;
        }

        this.type = type;
    }

    isValid() {
        if(this.type === "product") return externalShipmentAffProductScannedValidate(this);
        else if (this.type === "location") return externalShipmentAffLocationScannedValidate(this);
    }
}